import { ApiEndpointBuilder } from "@/services/api/types.ts";
import { ContractCategory, ContractEnterprise } from "@/types/contracts";
import { contractsApi } from "@/store/contracts/endpoints";

const updateEnterpriseEndPoint = (builder: ApiEndpointBuilder) => {
  return builder.mutation<string, Request>({
    query: ({ id, ...request }) => ({
      url: `/contracts/enterprisecontracts/${id}`,
      method: "PUT",
      body: {
        id,
        ...request,
      },
    }),

    async onQueryStarted(args, { dispatch, queryFulfilled }) {
      const patchFetchResult = dispatch(
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        //@ts-ignore
        contractsApi.util.updateQueryData("searchInfiniteContractEnterprises", {}, draftPosts => {
          return {
            ...draftPosts,
            data: [
              ...(draftPosts?.data ?? []).map(x =>
                x.id === args?.id
                  ? {
                      ...args,
                    }
                  : x
              ),
            ],
          };
        })
      );

      try {
        await queryFulfilled;
      } catch (err) {
        // Undo the cache update if an error occurs
        console.error(err);

        patchFetchResult.undo();
      }
    },
    invalidatesTags: (_r, _e, arg) => [{ type: "contract", id: arg.id }],
  });
};

export default updateEnterpriseEndPoint;

type Request = Partial<
  ContractEnterprise & {
    contractCategory: ContractCategory;
  }
> & {
  id: string;
};
